import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./shared/sentry";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import Progress from "./components/Progress";
import Providers from "./Providers";

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<Progress fill />}>
      <Providers>
        <App />
      </Providers>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals !!
reportWebVitals();
